// external
import { useEffect, useRef, useState } from "react";

// Thrive libraries
import { useObservable } from "thrive-observable-react";
import { BasicButton, IconLibrary, ThriveIcon } from "thrive-components";
import { 
    ChatEditorToPlaintextBody,
    IThriveText,
    ThriveText,
    ThriveTextConfigOptions,
    ChatEditorToPlainString,
    clearAndFocusEditor
} from "thrive-text";

// services
import { ConversationService } from "../../service/ChatConversation.Service";
import { CAS } from "../../service/ChatConfig.Service";

// interface
import { IMessageBody } from "../../interfaces";

// styles
import '../../styles/ChatComposeArea.scss';




const ChatComposeArea = () => { 

    const chatId = useObservable<number>(ConversationService.chatId);
    
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
      
    const editorRef = useRef<IThriveText>();

    useEffect(() => {
        if(editorRef.current) {
            clearAndFocusEditor(editorRef.current)
        }
    },[chatId])
    
    const options: ThriveTextConfigOptions  = {
        onReturnKeyPressed: (message: {body: IMessageBody}) => handleSendChat(message),
        hasEditorRef: true,
        editorRef: editorRef as any,
        onChange: (_, editor) => {
            if(editor) {
                setIsDisabled(ChatEditorToPlainString(editor).replaceAll('\n', '').length === 0);
            }
        }
   }

   function handleSendChat(message: {body: IMessageBody}) {
        if(!message.body.plainText) {
            return '';
        }

        ConversationService.handleMessageDirection(editorRef.current as IThriveText, message)

    }

    return (
        <section className='compose-area-wrapper'>
            <div className='compose-area'>
                <div className="no-flex-wrapper">
                     <ThriveText
                        key={chatId}
                        id="chat-compose-comments" 
                        placeholder={{text: CAS.localisationStrings.WriteAMessage(), className: 'chat-compose-placeholder'}}
                        options={options}
                    />
                </div>
               
                <div className="send-message-button-wrapper">
                    <BasicButton
                        className="send-message-button"
                        content={<ThriveIcon
                            iconName={IconLibrary.SEND}
                            color={isDisabled ? 'var(--thriveWhite)' : 'var(--chatFontColor)'}
                            sizeInPx="16"
                        />}
                        ariaLabel={CAS.localisationStrings.SendMessage()}
                        onButtonClick={() => !!editorRef.current && handleSendChat(ChatEditorToPlaintextBody(editorRef.current) as {body: IMessageBody})}
                        isDisabled={isDisabled}
                    />
                </div>
                
            </div>    
        </section>
    )
}

export default ChatComposeArea;